<template>
  <section class="content">
    <!--<template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">
          {{alert.message}}
        </p>
        <ul v-else>
          <li v-for="e in alert.message">
            {{e}}
          </li>
        </ul>
      </b-alert>
    </template>-->
    <div class="modal fade" id="help-basic" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>Hilfe</h4>
          </div>
          <div class="modal-body">
            <h4>Basisparameter</h4>
            <p class="lead">Diese Parameter müssen nur einmalig eingegeben werden, da sie sich im Wesentlichen nicht ständig ändern.
            </p>
              <ul>
                  <li><strong>Stundensatz:</strong> Durchschnittlicher effektiver Stundensatz der Mitarbeiter für die Bearbeitungsdauern der Bestellung und der Retoure, z.B. '13,5'€/h</li>
                  <li><strong>MwSt.Satz:</strong> Derzeit in Deutschland '19'%.</li>
                  <li><strong>Verpackungskosten:</strong> Summe aller Verpackungskosten (Kartonagen, Packband, Schrenzpapier, Papiere, Klebelabels, Tinte/Toner...) z.B. '0,4'€.</li>
                  <li><strong>NOS-Artikelsaisonziffer:</strong> Saisonkennziffer der Warenwirtschaft für NOS-Ware, z.B. '9'.</li>
                  <li><strong>Altwarensaisonziffer:</strong> Saisonkennziffer der Warenwirtschaft für Altware-Ware, z.B. '0'.</li>
                  <li><strong>Bearbeitungsdauer Versand:</strong> Durchschnittliche Bearbeitungsdauer des Versandes der Ware (Suchen, anhübschen, ausbuchen, verpacken, versenden...), z.B. '7,5' min.</li>
                  <li><strong>Bearbeitungsdauer Retoure:</strong> Durchschnittliche Bearbeitungsdauer bei einer Retoure (annehmen, auspacken, prüfen, erstatten, wiedereinbuchen, anhübschen, aufräumen...), z.B. '9,5' min.</li>
              </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="help-rendite" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>Hilfe</h4>
          </div>
          <div class="modal-body">
            <h4>Mindestrendite</h4>
            <p class="lead">Legen Sie hier Ihre gewünschten Ertrags- oder Renditeoptionen fest, die mindestens erreicht werden müssen. (NICHT 'sollen', sondern 'müssen'!)
              Für jede Bestellung müssen BEIDE Kriterien erfüllt sein, z.B. mindestens 4€ (absolut) und mindestens 6% des erzielten VK-Preises (relativ).
            </p>
            <p>
              Beispiele:
            </p>
              <ul>
                <li>Verkaufspreis 100€: 6€ Mindestrendite </li>
                <li>Verkaufspreis 50€: 4€ Mindestrendite</li>
              </ul>
              <br/>
              <p>
                <strong>Soll-Ertrag absolut:</strong>  Der Eurobetrag, der mindestens als Rendite erzielt werden muss. Z.B. '4'€   <br/>
                <strong>Soll-Ertrag relativ:</strong> : Der Anteil des erzielten Verkaufspreises, der als Rendite erzielt werden muss. Z.B. '6,5'%.
              </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="help-rabatte" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>Hilfe</h4>
          </div>
          <div class="modal-body">
            <h4>Hersteller Rabatte</h4>
            <p class="lead">
              Hier können für jeden Hersteller individuell Rabatte zum Listen-EK (der vom WWS übermittelt wird) eingegeben werden.
            </p>
            <p>
              Diese drücken den effektiven EK und setzen somit den Mindestpreis beim Onlineverkauf herab. Da nicht alle Rabatte in der Wawi gepflegt werden (z.B. nachgelagerte Rabatte, Skoni, Boni, Rückvergütungen), ist diese Option vorhanden. Auch starke Unterschiede zwischen Vor- und Nachorderrabatten können hier 'gemittelt' eingegeben werden. Z.B. 'Rieker': '5,3'%.
                <br/>
                <br/>
                <strong>Fallback:</strong> Falls der Rabatt des Herstellers nicht individuell konfiguriert ist, wird dieser Rabattsatz angelegt, z.B. '2,2'%.<br/>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="help-marktplatz" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>Hilfe</h4>
          </div>
          <div class="modal-body">
            <h4>Marktplatz Parameter</h4>
            <p class="lead">
              Jeder Marktplatz hat unterschiedliche Parameter (Kostensätze, Porti, Retourenquoten), die hier gepflegt werden müssen.
            </p>
            <ul>
              <li><strong>Provision MP:</strong> Verkaufsprovision des Marktplatzes, z.B. '15'% bei Amazon.</li>
              <li><strong>Provision andere:</strong> andere verkaufspreis-abhängige Provisionen, z.B. Schnittstellengebühr. Z.B. '1'%.</li>
              <li><strong>Porto Versand:</strong> (mittleres) Porto für den Versand, z.B. '3,3'€.</li>
              <li><strong>Porto Retoure:</strong> (mittleres) Porto für die Retoure, z.B. '4,8'€.</li>
              <li><strong>Bearbeitungsgebühr MP:</strong> Fixkosten, die beim Versand zusätzlich erhoben werden, z.B. '3'€ bei schuhe24.</li>
              <li><strong>Erstattung Retoure:</strong> Zurückerstattete Verkaufsprovision bei Retouren, z.B. '12'% bei Amazon.</li>
              <li><strong>Bearbeitung Retoure:</strong>  Fixkosten, die bei einer Retoure zusätzlich erhoben werden, z.B. '2,5'€ bei schuhe.de.</li>
              <li><strong>Rücksendequote:</strong>  Die erwartete Rücksendequote des Marktplatzes, z.B. '65%' bei Zalando oder '30%' bei Amazon.</li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="help-reduction" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>Hilfe</h4>
          </div>
          <div class="modal-body">
            <h4>Abwertungstabelle</h4>
            <p class="lead">
              Somit wird sichergestellt, dass alte Artikel noch (mit geringerem Preis) verkauft werden können.
              Für jede Saison kann ein Abwertungssatz eingegeben werden, z.B. 'Saison-5':'25'% (Der EK zur Berechnung des Mindestpreises für zweieinhalb Jahre Alte Artikel ist somit der (Listen-EK - Herstellerrabatt) -25%).
              <br/>
              <br/>
              Abwertungen besonderer Saisons sind:
              <ul>
                <li>'Aktuell' (Kennzeichen wird oben definiert)</li>
                <li>'NOS' (Kennzeichen ebenfalls oben definiert)</li>
                <li>'Altware', alles, was älter als 'Saison-10' bekommt diesen Abwertungssatz.</li>
              </ul>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="help-return" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-question-circle mr-5"></i>Hilfe</h4>
          </div>
          <div class="modal-body">
            <h4>Mindestrendite</h4>
            <p class="lead">So konfigurieren Sie die korrekten Einstellungen</p>
            <p>Jemand musste Josef K. verleumdet haben, denn ohne dass er etwas Böses getan hätte, wurde er eines Morgens verhaftet. »Wie ein Hund!« sagte er, es war, als sollte die Scham ihn überleben. Als Gregor Samsa eines Morgens aus unruhigen Träumen erwachte, fand er sich in seinem Bett zu einem ungeheueren Ungeziefer verwandelt. Und es war ihnen wie eine Bestätigung ihrer neuen Träume und guten Absichten, als am Ziele ihrer Fahrt die Tochter als erste sich erhob und ihren jungen Körper dehnte. »Es ist ein eigentümlicher Apparat«, sagte der Offizier zu dem Forschungsreisenden und überblickte mit einem gewissermaßen bewundernden Blick den ihm doch wohlbekannten Apparat.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="brand" tabindex="-1" role="dialog" aria-labelledby="history_ModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-plus mr-5"></i>{{'new_manufacturer_discount' | translate}}</h4>
          </div>
          <div class="modal-body">
            <label>{{'add_manufacturer_discount' | translate}}:</label>
            <div class="input-group mt-10">
              <span class="input-group-addon"><strong>{{'manufacturer' | translate}}</strong></span>
              <select class="form-control" v-model="merchantOffer.id">
                <option value="0" class="normal" selected>Hersteller wählen...</option>
                <template v-for="merchant in manufacturers">
                  <option class="normal" :value="merchant.id">{{merchant.name}}</option>
                </template>
              </select>
            </div>
            <div class="margin"></div>
            <div class="input-group">
              <span class="input-group-addon"><strong>Rabatt in %</strong></span>
              <input type="text" class="form-control" placeholder="Rabatt in %" value="" v-model="merchantOffer.discount">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>Schließen</button>
            <button type="button" class="btn btn-app no-margin btn-success" data-dismiss="modal" @click="()=>{companyManufacturers.push(merchantOffer); postMerchants()}"><span class="fa fa-save"></span>{{'save' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-euro mr-5"></i>{{'uvp_title' | translate}}</h3>
        <div class="box-tools pull-right" data-toggle="tooltip" title="" data-original-title="Minimize">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        </div>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <p class="lead">{{'uvp_box_header' | translate}}<br/>{{'uvp_box_header_2' | translate}}<br/>{{'uvp_box_header_3' | translate}}</p>
            <p class="text-warning"><i class="fa fa-exclamation-triangle mr-5"></i><strong>{{'uvp_box_warning' | translate}}</strong></p>
            <p class="text-danger"><i class="fa fa-exclamation-triangle mr-5"></i><strong>{{'uvp_box_warning_2' | translate}}</strong></p>
          </div>
        </div>
      </div>
      <div class="box-body">
       <!-- <div class="row">
          <div class="col-md-6 col-sm-8 col-xs-12">
            <h4>Aktivierung des UVP Online Preismodules
              <sup class="text-muted ml-5" title="Hilfe öffen"><a href="#" data-toggle="modal" data-target="#help"><i class="fa fa-question-circle"></i></a></sup>
            </h4>
            <p>Bitte wählen Sie hier, ob die UVP Preisregeln bei Ihnen aktiviert werden sollen.<br>
              <small>Mit Aktivierung bestätigen Sie die aktuellen <a class="text-primary" href="https://s3.eu-central-1.amazonaws.com/production.qb-schuhe.de/download-center/5a8560d6e8b67.pdf?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Security-Token=FQoGZXIvYXdzEAYaDM7exp6ba30G6UbYfSK9A5svmPsIA7cWVTNDdLkgRmOTLW7dTb9piB55edDtRisLtjiau1L1AyrcuomBiISwsqcoOn8oD%2BbMslV0iSPfbN12YpnH6cF2uUPtJ%2BSaRHz8aNd6VfdJKuTXxeB1VfyCftvRfQYIAb673JA27p2R4OyGx4zlF8QYL71NOACwSP%2BnHLB1O%2F5GifgpFKfWxV%2F%2FgG%2FulthQKjD6qCFQbIPpw9yXA1Us8GOiXLxUIMrw9mFCDmnlI3k1Fyw0js3sULJo%2B%2FnlUHxofPty2Ccty04lBqK4yDMlDY5YHK1cYRrhAIKPJPv%2FtC5to6g32XYtMv1ksyApdgduxvgxfltC6ETFjps1EflTY7exiW7HPLyvu2uqQMn92I%2FWWAlWd7n0JjAIys0ubNM2IKpyvUtoljLiMsUvgXkb%2B4SLUpNSMalKpVw6sxtXV5Vl2jMvxAxMz27vmBB40elw95DD1X%2BtY88iGPCpFEHsXylgcLgOi9kGzJd6kzz9GHXZDYdV%2FvrIIe8Hcyd33g0er%2FZctg1DVHBsl9rnNuJn6Okm5oxYVfmQhA0ZDYLi7wNBdX0hcx%2BpcnI9awaoE7mJsFNgLe6Gi9Mo5baB2wU%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXFKXYD37EXHR5CEU%2F20180731%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20180731T133441Z&X-Amz-SignedHeaders=host&X-Amz-Expires=900&X-Amz-Signature=211ce0f6d947e5b0dce607a8dfab3d7ae05cdba96e2b2ffeaa3fa53f595876fc" target="_blank">AGB's</a> gelesen und akzeptiert zu haben.</small>
            </p>
          </div>
          <div class="col-md-6 col-sm-4 col-xs-12">
            <div class="btn-group" data-toggle="btn-toggle">
              <button @click="() => {config.is_active = true; postConfig(['is_active'])}" type="button" :class="['btn btn-success btn-app', config.is_active ? 'active' : '']"><i class="fa fa-check"></i>{{'is_active' | translate}}</button>
              <button @click="() => {config.is_active = false;  postConfig(['is_active'])}" type="button" :class="['btn btn-danger btn-app', config.is_active ? '' : 'active']"><i class="fa fa-ban"></i>{{'inactive' | translate}}</button>
            </div>
          </div>
        </div>
        <hr>-->
        <div class="row">
          <div class="col-xs-12">
            <h4>{{'basic_parameters' | translate}}
              <sup class="text-muted ml-5" title="Hilfe öffen"><a href="#" data-toggle="modal" data-target="#help-basic"><i class="fa fa-question-circle"></i></a></sup>
            </h4>
            <p><small class="text-muted">{{'basic_parameters_desc' | translate}}</small></p>
            <div class="margin"></div>
          </div>
          <div class="col-lg-4 col-md-6 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'hour_rate_desc' | translate">
              <span class="input-group-addon">{{'hour_rate' | translate}}</span>
              <input type="text" class="form-control" placeholder="in € / h" v-model="config.hourly_wage">
              <span class="input-group-addon"><i class="fa fa-clock-o text-muted"></i></span>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'vat_rate_desc' | translate">
              <span class="input-group-addon">{{'vat_rate' | translate}}</span>
              <input type="text" class="form-control" placeholder="in %" v-model="config.tax_rate">
              <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'packaging_cost_desc' | translate">
              <span class="input-group-addon">{{'packaging_cost' | translate}}</span>
              <input type="text" class="form-control" placeholder="in €" v-model="config.package_cost">
              <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'nos_session_title' | translate">
              <span class="input-group-addon">{{'nos_session' | translate}}</span>
              <select class="form-control" v-model="config.season_nos">
                <option value="0" class="normal">Saison wählen...</option>
                <template v-for="season in seasons">
                  <option :value="season.id" class="normal">{{season.name}}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'old_title' | translate">
              <span class="input-group-addon">{{'old' | translate}}</span>
              <select class="form-control" v-model="config.season_old">
                <option value="0" class="normal">Saison wählen...</option>
                <template v-for="season in seasons">
                  <option :value="season.id" class="normal">{{season.name}}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'time_to_ship_desc' | translate">
              <span class="input-group-addon">{{'time_to_ship' | translate}}</span>
              <input type="text" class="form-control" placeholder="in min" v-model="config.processing_duration_shipping">
              <span class="input-group-addon"><i class="fa fa-clock-o text-muted"></i></span>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'time_to_return_desc' | translate">
              <span class="input-group-addon">{{'time_to_return' | translate}}</span>
              <input type="text" class="form-control" placeholder="in min" v-model="config.processing_duration_return">
              <span class="input-group-addon"><i class="fa fa-clock-o text-muted"></i></span>
            </div>
          </div>
        </div>
        <div class="margin"></div>
        <div class="row pt-10">
          <div class="col-xs-12 text-right">
            <b-btn @click="postConfig(['hourly_wage', 'tax_rate', 'package_cost', 'season_nos', 'season_old', 'processing_duration_shipping', 'processing_duration_return'])" class="btn btn-success btn-sm"><i class="fa fa-save mr-5"></i>{{'save_changes' | translate}}</b-btn>
          </div>
        </div>
        <hr>
        <!-- ROI -->
        <div class="row">
          <div class="col-xs-12">
            <h4>{{'desired_roi' | translate}}
              <sup class="text-muted ml-5" title="Hilfe öffen"><a href="#" data-toggle="modal" data-target="#help-rendite"><i class="fa fa-question-circle"></i></a></sup>
            </h4>
            <p><small class="text-muted">{{'desired_roi_desc' | translate}}</small></p>
            <div class="margin"></div>
          </div>
          <div class="col-lg-6 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'absolute_yield_desc' | translate">
              <span class="input-group-addon">{{'absolute_yield' | translate}}</span>
              <input type="text" class="form-control" placeholder="in €" v-model="config.expected_yield_absolute">
              <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-xs-12">
            <div class="margin"></div>
            <div class="input-group" :title="'relative_yield_desc' | translate">
              <span class="input-group-addon">{{'relative_yield' | translate}}</span>
              <input type="text" class="form-control" placeholder="in %" v-model="config.expected_yield_relative">
              <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
            </div>
          </div>
        </div>
        <div class="margin"></div>
        <div class="row pt-10">
          <div class="col-xs-12 text-right">
            <b-btn @click="postConfig(['expected_yield_absolute', 'expected_yield_relative'])" class="btn btn-success btn-sm"><i class="fa fa-save mr-5"></i>{{'save_changes' | translate}}</b-btn>
          </div>
        </div>
        <hr>
        <!-- SAISON -->
        <div class="row">
          <div class="col-xs-12">
            <h4>{{'current_season' | translate}}</h4>
            <p><small class="text-muted">Saisonkennziffer der Warenwirtschaft der derzeit
              aktuellen Saison, wird für die EK-Abwertung von Bestandsware benötigt.
              DIESER PARAMETER MUSS BEIM SAISONWECHSEL JEWEILS ANGEPASST WERDEN! z.B. '51'. </small></p>
            <div class="margin"></div>
          </div>
          <div class="col-lg-4 col-md-6 col-xs-12">
            <div class="margin"></div>
            <div class="input-group">
              <span class="input-group-addon">{{'current_season' | translate}}</span>
              <select class="form-control" v-model="config.season_current" @change="postConfig(['season_current'])">
                <option value="0" class="normal">Saison wählen...</option>
                <template v-for="season in seasons">
                  <option :value="season.id" class="normal">{{season.name}}</option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <hr>
        <!-- HERSTELLERRABATTE -->
        <div class="row">
          <div class="col-xs-12">
            <h4>Hersteller Rabatte
              <sup class="text-muted ml-5" title="Hilfe öffen"><a href="#" data-toggle="modal" data-target="#help-rabatte"><i class="fa fa-question-circle"></i></a></sup>
            </h4>
            <p><small class="text-muted">Definieren Sie Ihre Rabatte, die zusätzlich zu den in der Warenwirtschaft gepflegten EKs gewährt werden.</small></p>
            <div class="margin"></div>
          </div>
          <div class="col-xs-12">
            <div class="box-group" id="brand_accordion">
              <div class="panel box no-border">
                <div class="box-header no-border no-padding">
                  <a class="btn btn-sm btn-outline" data-toggle="collapse" data-parent="#brand_accordion" href="#brandOne">
                    <i class="fa fa-sort text-muted mr-5"></i>Liste ein-/ausblenden
                  </a>
                </div>
                <div id="brandOne" class="panel-collapse collapse">
                  <div class="pt-10 pb-10">
                    <div class="row">
                      <div class="clear"></div>
                      <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="input-group">
                          <span class="input-group-addon">Fallback</span>
                          <input type="text" class="form-control" placeholder="z.B. 10.0%" v-model="config.manufacturer_discount_fallback">
                          <span class="input-group-btn">
                              <button class="btn btn-success" @click="postConfig(['manufacturer_discount_fallback'])"><i class="fa fa-save"></i></button>
                          </span>
                        </div>
                        <span class="help-block small text-warning">{{'manufacturers_warning' | translate}}</span>
                      </div>
                      <div class="clear"></div>
                    </div>
                    <template v-if="companyManufacturers && manufacturers  && manufacturers.length > 0 && companyManufacturers.length > 0">
                      <hr>
                      <div class="row">
                        <template v-for="(merchant, index) in companyManufacturers">
                          <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                            <div class="input-group">
                              <span class="input-group-addon">{{manufacturers.find(a => a.id === merchant.id).name}}</span>
                              <input type="text" class="form-control" placeholder="z.B. 10.0%" v-model="merchant.discount">
                              <span class="input-group-btn">
                                <button class="btn btn-success" @click="postMerchants"><i class="fa fa-save"></i></button>
                                <button class="btn btn-danger" @click="deleteMerchant(index)"><i class="fa fa-trash"></i></button>
                            </span>
                            </div>
                            <div class="margin"></div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div class="box-footer no-padding">
                    <div class="row pt-10 pb-10">
                      <div class="col-xs-12">
                        <a href="#" class="btn btn-info" data-toggle="modal" data-target="#brand">Neuer Rabatt<i class="fa fa-plus ml-5"></i></a>
                      </div>
                    </div>
                    <div class="margin"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <!-- ABWERTUNGSTABELLE -->
        <div class="row">
          <div class="col-xs-12">
            <h4>Abwertungstabelle
              <sup class="text-muted ml-5" title="Hilfe öffen"><a href="#" data-toggle="modal" data-target="#help-reduction"><i class="fa fa-question-circle"></i></a></sup>
            </h4>
            <p><small class="text-muted">Der EK jedes Artikels wird über das Alter abgewertet. In dieser Tabelle können die Werte für die Teilwertsätze abgespeichert werden (analog zur Warenbewertung in der Bilanz)</small></p>
            <div class="margin"></div>
          </div>
          <div class="col-xs-12">
            <div class="box-group" id="devaluation_table">
              <div class="panel box no-border">
                <div class="box-header no-border no-padding">
                  <a class="btn btn-sm btn-outline" data-toggle="collapse" data-parent="#devaluation_table" href="#devaluation">
                    <i class="fa fa-sort text-muted mr-5"></i>Tabelle ein-/ausblenden
                  </a>
                </div>
                <div id="devaluation" class="panel-collapse collapse">
                  <div class="pt-10 pb-10">
                    <div class="row">
                      <div class="col-lg-3 col-md-6 col-xs-12">
                        <div class="margin"></div>
                        <div class="input-group">
                          <span class="input-group-addon">{{'current' | translate}}</span>
                          <input type="text" class="form-control" placeholder="in %" v-model="config.season_devalue_current">
                          <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-6 col-xs-12">
                        <div class="margin"></div>
                        <div class="input-group">
                          <span class="input-group-addon">NOS</span>
                          <input type="text" class="form-control" placeholder="in %" v-model="config.season_devalue_nos">
                          <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-6 col-xs-12">
                        <div class="margin"></div>
                        <div class="input-group">
                          <span class="input-group-addon">{{'old' | translate}}</span>
                          <input type="text" class="form-control" placeholder="in %" v-model="config.season_devalue_old">
                          <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-6 col-xs-12">
                        <div class="margin"></div>
                        <div class="input-group">
                          <span class="input-group-addon">{{'future' | translate}}</span>
                          <input type="text" class="form-control" placeholder="in %" v-model="config.season_devalue_future">
                          <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                        </div>
                      </div>
                      <template v-for="season in companyDevaluations">
                        <div class="col-lg-3 col-md-6 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group">
                            <span class="input-group-addon">Saison -{{season.season_count}}</span>
                            <input type="text" class="form-control" placeholder="in %" v-model="season.discount">
                            <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="margin"></div>
                    <div class="row pt-10">
                      <div class="col-xs-12 text-right">
                        <b-btn @click="postSeasons" class="btn btn-success btn-sm"><i class="fa fa-save mr-5"></i>{{'save_changes' | translate}}</b-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <!-- MARKETPLACES STUFF -->
        <div class="row">
          <div class="col-xs-12">
            <h4>{{'marketplace_parameters' | translate}}
              <sup class="text-muted ml-5" title="Hilfe öffen"><a href="#" data-toggle="modal" data-target="#help-marktplatz"><i class="fa fa-question-circle"></i></a></sup>
            </h4>
            <p><small class="text-muted">{{'marketplace_desc' | translate}}</small></p>
            <div class="margin"></div>
          </div>
          <div class="clear"></div>
          <div class="col-xs-12">
            <div class="box-group">
              <template v-for="(mp, index) in companyChannels">
                <div class="panel box no-border">
                  <div class="box-header with-border no-padding">
                    <a data-toggle="collapse" data-parent="#accordion" :href="'#collapse'+mp.name">
                      <h5><i class="fa fa-cogs text-muted mr-5"></i>{{mp.name | translate}}<img class="img-channel pull-right" :src="`/static/img/${getMpName(mp.name)}.svg`"></h5>
                    </a>
                  </div>
                  <div :id="`collapse${mp.name}`" :class="['panel-collapse','collapse', index === 0 ? 'in': '']">
                    <div class="pt-10 pb-10">
                      <div class="row">
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Provision, die durch den Marktplatz erhoben wird in Prozent">
                            <span class="input-group-addon">Provision MP</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.commission_marketplace">
                            <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Provision durch Drittanbieter (WWS,Schnittstelle, etc.) in Summe in Prozent">
                            <span class="input-group-addon">Provision andere</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.commission_other">
                            <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Portokosten für den Versand in EURO">
                            <span class="input-group-addon">Porto Versand</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.postage_shipping">
                            <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Portokosten für die Retoure in EURO">
                            <span class="input-group-addon">Porto Retoure</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.postage_return">
                            <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Versandkosten, die der Marktplatz erhebt in EURO">
                            <span class="input-group-addon">Bearbeitungsgebühr MP</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.marketplace_shipping_cost">
                            <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Rückerstattung für Retouren in Prozent">
                            <span class="input-group-addon">Erstattung Retoure</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.commission_return_refund">
                            <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Bearbeitungskosten für Retouren in EURO">
                            <span class="input-group-addon">Bearbeitung Retoure</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.marketplace_return_cost">
                            <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <div class="margin"></div>
                          <div class="input-group" title="Rücksendequote in Prozent">
                            <span class="input-group-addon">Rücksendequote</span>
                            <input type="text" class="form-control" placeholder="0" v-model="mp.return_quota">
                            <span class="input-group-addon"><i class="fa fa-percent text-muted"></i></span>
                          </div>
                        </div>
                      </div>
                      <div class="margin"></div>
                      <div class="row pt-10">
                        <div class="col-xs-12 text-right">
                          <b-btn @click="postChannels([mp])" class="btn btn-success btn-sm"><i class="fa fa-save mr-5"></i>{{'save_changes' | translate}}</b-btn>
                        </div>
                      </div>
                    </div>
                    <div class="box-footer no-padding"></div>
                  </div>
                </div>
              </template>
            </div>
            <div class="margin"></div>
          </div>
        </div>
      </div>
      <div class="box-footer no-border">
        <div class="row hidden">
          <div class="col-xs-12 text-right text-center-xs">
            <a href="#" class="btn btn-success btn-app no-margin"><i class="fa fa-save"></i>Speichern</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-euro text-muted mr-5"></i>Mindestverkaufspreis Rechner</h3>
            <div class="box-tools pull-right" data-toggle="tooltip" title="" data-original-title="Öffnen">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: block;">
            <p>Hier kann als Pausibilitätstest für einen gegebenen Listen-EK eines Herstellers aus einer gegebenen Saison der Mindestpreis für die Marktplätze errechnet werden, so wie sie oben konfiguriert sind.</p>
            <div class="margin"></div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">Listen EK</span>
                  <input v-validate="{required: true, regex: /^(?=.*\d)\d*(?:\,\d{0,2})?$/}" type="text" name="vkminPrice" class="form-control" placeholder="in €" v-model="vkminPrice">
                  <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                </div>
                <span v-show="errors.has('vkminPrice')" class="small text-danger">{{ errors.first('vkminPrice') }}</span>
                <div class="margin"></div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">{{'season' | translate}}</span>
                  <select class="form-control" v-model="vkminSeason">
                    <option value="0" class="normal">Saison wählen...</option>
                    <template v-for="season in seasons">
                      <option :value="season.id" class="normal">{{season.name}}</option>
                    </template>
                  </select>
                </div>
                <div class="margin"></div>
              </div>
              <div class="col-xs-12">
                <div class="input-group">
                  <span class="input-group-addon">{{'manufacturer' | translate}}</span>
                  <vue-multiselect :options="manufacturers" label="name" track-by="id" placeholder="Hersteller wählen..." v-model="vkminManufacturer"></vue-multiselect>
                </div>
                <div class="margin"></div>
              </div>
            </div>
            <div class="row">
              <div v-if="vkminResult && Object.keys(vkminResult).length > 0">
                <div class="margin"></div>
                <div class="table-responsive">
                  <table class="table no-margin table-hover">
                    <thead>
                    <tr>
                      <th>Wert</th>
                      <th>Einheit</th>
                      <th v-for="key in Object.keys(vkminResult)">{{key | translate}}</th>
                    </tr>
                    </thead>
                    <tbody class="small text-muted">
                    <tr>
                      <td>EK abgewertet</td>
                      <td><i class="fa fa-euro"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].cost_price_devalued">{{vkminResult[key].cost_price_devalued}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Arbeitskosten Versand</td>
                      <td><i class="fa fa-euro"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].labor_costs_shipping">{{vkminResult[key].labor_costs_shipping}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Arbeitskosten Retoure</td>
                      <td><i class="fa fa-euro"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].labor_costs_return">{{vkminResult[key].labor_costs_return}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Provision Versand</td>
                      <td><i class="fa fa-percent"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].commission_shipping">{{vkminResult[key].commission_shipping}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Provision Retoure</td>
                      <td><i class="fa fa-percent"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].commission_return">{{vkminResult[key].commission_return}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Kosten Versand</td>
                      <td><i class="fa fa-euro"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].cost_shipping">{{vkminResult[key].cost_shipping}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Kosten Retoure</td>
                      <td><i class="fa fa-euro"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].cost_return">{{vkminResult[key].cost_return}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                      <td><strong>UVP-Online</strong></td>
                      <td><i class="fa fa-euro text-muted"></i></td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].selling_price_min">{{vkminResult[key].selling_price_min}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Kalkulation</strong></td>
                      <td>&nbsp;</td>
                      <td v-for="key in Object.keys(vkminResult)">
                        <span v-if="vkminResult[key] && vkminResult[key].calculation">{{vkminResult[key].calculation}}</span>
                        <span v-else>&nbsp;</span>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
                <div class="margin"></div>
              </div>
            </div>
            <div class="row hidden"></div>
          </div>
          <div class="box-footer text-right" style="display: block;">
            <button type="button" class="btn btn-app no-margin btn-success" :disabled="errors.has('vkminPrice') || vkminManufacturer === 0 || vkminSeason === 0" @click="calculateVkmin"><span class="fa fa-calculator"></span>Rechnen</button>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-line-chart text-muted mr-5"></i>Rendite Rechner</h3>
            <div class="box-tools pull-right" data-toggle="tooltip" title="" data-original-title="Öffnen">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-body">
            <p>Für einen gegebenen Verkaufspreis kann die Rendite errechnet werden, individuell für die Marktplätze wie oben konfiguriert.</p>
            <div class="margin"></div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">Listen-EK</span>
                  <input v-validate="{required: true, regex: /^(?=.*\d)\d*(?:\,\d{0,2})?$/}" type="text" name="roiPrice" class="form-control" placeholder="in €" v-model="roiPrice">
                  <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                </div>
                <span v-show="errors.has('roiPrice')" class="small text-danger">{{ errors.first('roiPrice') }}</span>
                <div class="margin"></div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">Verkaufspreis</span>
                  <input v-validate="{required: true, regex: /^(?=.*\d)\d*(?:\,\d{0,2})?$/}" type="text" name="roiSellingPrice" class="form-control" placeholder="in €" v-model="roiSellingPrice">
                  <span class="input-group-addon"><i class="fa fa-euro text-muted"></i></span>
                </div>
                <span v-show="errors.has('roiSellingPrice')" class="small text-danger">{{ errors.first('roiSellingPrice') }}</span>
                <div class="margin"></div>
              </div>
              <div class="clearfix"></div>
              <div class="col-md-6 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">{{'season' | translate}}</span>
                  <select class="form-control" v-model="roiSeason">
                    <option value="0" class="normal">Saison wählen...</option>
                    <template v-for="season in seasons">
                      <option :value="season.id" class="normal">{{season.name}}</option>
                    </template>
                  </select>
                </div>
                <div class="margin"></div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="input-group">
                  <span class="input-group-addon">{{'manufacturer' | translate}}</span>
                  <vue-multiselect :options="manufacturers" label="name" track-by="id" placeholder="Hersteller wählen..." v-model="roiManufacturer"></vue-multiselect>
                </div>
                <div class="margin"></div>
              </div>
            </div>
            <div class="row" v-if="roiResult && Object.keys(roiResult).length > 0">
              <div class="col-xs-12">
                <div>
                  <div class="margin"></div>
                  <div class="table-responsive">
                    <table class="table no-margin table-hover">
                      <thead>
                      <tr>
                        <th>Wert</th>
                        <th>Einheit</th>
                        <th v-for="key in Object.keys(roiResult)">{{key | translate}}</th>
                      </tr>
                      </thead>
                      <tbody class="small text-muted">
                      <tr>
                        <td>VK erzielt</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].selling_price">{{roiResult[key].selling_price}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Rohgewinn Versand</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].raw_profit_shipping">{{roiResult[key].raw_profit_shipping}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Rohgewinn nach Retouren</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].selling_price">{{roiResult[key].raw_profit_return}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Kosten Versand</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].cost_shipping">{{roiResult[key].cost_shipping}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Kosten Retoure effektiv</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].cost_return">{{roiResult[key].cost_return}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Provision Versand</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].commission_shipping">{{roiResult[key].commission_shipping}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Provision Retoure</td>
                        <td><i class="fa fa-euro"></i></td>
                        <td v-for="key in Object.keys(roiResult)">
                          <span v-if="roiResult[key] && roiResult[key].commission_return">{{roiResult[key].commission_return}}</span>
                          <span v-else>&nbsp;</span>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td><strong>Gewinn/Verlust</strong></td>
                        <td><i class="fa fa-euro text-muted"></i></td>
                        <template v-for="key in Object.keys(roiResult)">
                          <td v-if="roiResult[key] !== null" :class="getClass(roiResult[key].raw_profit, config.expected_yield_absolute)"><strong>{{roiResult[key].raw_profit}}</strong></td>
                          <td v-else>&nbsp;</td>
                        </template>
                      </tr>
                      <tr>
                        <td><strong>Relativ zum Umsatz</strong></td>
                        <td><i class="fa fa-percent text-muted"></i></td>
                        <template v-for="key in Object.keys(roiResult)">
                          <td  v-if="roiResult[key] !== null" :class="getClass(roiResult[key].relative_to_sales, config.expected_yield_relative)"><strong>{{roiResult[key].relative_to_sales}}</strong></td>
                          <td v-else>&nbsp;</td>
                        </template>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                  <hr>
                  <div><p class="small text-success">* Werte, die die voreingestellten Optionen erfüllen</p></div>
                  <div><p class="small text-warning">* Werte, die die voreingestellten Optionen nicht erfüllen</p></div>
                  <div><p class="small text-danger">* Werte, die die Negativ-Erträge bilden</p></div>
                  <div class="margin"></div>
                </div>
              </div>
            </div>
            <div class="row hidden">
              <div class="col-xs-12">
                <hr>
                <label>Vergleich für folgende Marktplätze anzeigen:</label>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 ol-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success active"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger"><i class="fa fa-ban"></i></div>
                </div>
                <small>schuhe.de</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success active"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger"><i class="fa fa-ban"></i></div>
                </div>
                <small>amazon</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success active"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger"><i class="fa fa-ban"></i></div>
                </div>
                <small>amazon prime</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success active"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger"><i class="fa fa-ban"></i></div>
                </div>
                <small>zalando</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success active"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger"><i class="fa fa-ban"></i></div>
                </div>
                <small>eBay</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger active"><i class="fa fa-ban"></i></div>
                </div>
                <small>allYouNeed</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger active"><i class="fa fa-ban"></i></div>
                </div>
                <small>spartoo</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger active"><i class="fa fa-ban"></i></div>
                </div>
                <small>rakuten</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger active"><i class="fa fa-ban"></i></div>
                </div>
                <small>real</small>
                <div class="margin"></div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="btn-group mr-5" data-toggle="btn-toggle">
                  <div class="btn btn-xs btn-success"><i class="fa fa-check"></i></div>
                  <div class="btn btn-xs btn-danger active"><i class="fa fa-ban"></i></div>
                </div>
                <small>schuhe24</small>
                <div class="margin"></div>
              </div>
            </div>
          </div>
          <div class="box-footer text-right">
            <button type="button" class="btn btn-app no-margin btn-success" data-toggle="collapse" data-target="#calculate_return" :disabled="errors.has('roiSellingPrice') || errors.has('roiPrice') || roiManufacturer === 0 || roiSeason === 0" @click="calculateRoi"><span class="fa fa-calculator"></span>Rechnen</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
    import VueMultiselect from "../../../../node_modules/vue-multiselect/src/Multiselect";
export default {
    components: {VueMultiselect},
  name: 'UVP',
  data () {
    return {
      alerts: [],
      config: {},
      companyDevaluations: [],
      companyManufacturers: [],
      companyChannels: [],
      manufacturers: [],
      salesChannels: [],
      seasons: [],
      merchantOffer: {
        id: 0,
        discount: ''
      },
      vkminPrice: '',
      vkminSeason: 0,
      vkminManufacturer: { id: 0, name: "Hersteller wählen..." },
      vkminResult: {},
      roiPrice: '',
      roiSellingPrice: '',
      roiSeason: 0,
      roiManufacturer: { id: 0, name: "Hersteller wählen..." },
      roiResult: {}
    }
  },
  computed: {
  },
  methods: {
    getMpName (mp) {
      return mp  === 'schuhede-parent' ? mp.split('-')[0] : `schuhede-${mp}`
    },
    postConfig (data) {
      let toSend = {}
      data.forEach(k => {
        toSend[k] = k !== 'is_active' && typeof this.config[k] !== 'undefined' ? parseFloat(this.config[k].toString().replace(',', '.')) : this.config[k]
      })
      API.put('uvp/configuration', toSend)
        .then(res => {
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
        })
    },
    postMerchants () {
      this.reverseFormat(this.companyManufacturers)
      API.post('uvp/manufacturers', this.companyManufacturers)
        .then(res => {
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
        })
    },
    postSeasons () {
      this.reverseFormat(this.companyDevaluations)
      API.post('uvp/devaluations', this.companyDevaluations)
        .then(res => {
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
        })
      this.postConfig(['season_devalue_current', 'season_devalue_future', 'season_devalue_nos', 'season_devalue_old'])
    },
    deleteMerchant (index) {
      this.companyManufacturers.splice(index, 1)
      this.postMerchants()
    },
    generateDevaluations () {
      let ret = []
      for (let i = 1; i <= 10; i++) {
        ret.push({season_count: i, discount: 0})
      }
      return ret
    },
    generateChannels () {
      this.salesChannels.forEach(s => {
        if (!this.companyChannels.find(a => { return a.name === s.name })) {
          this.companyChannels.push({
            name: s.name,
            return_quota: '',
            marketplace_shipping_cost: '',
            marketplace_return_cost: '',
            commission_marketplace: '',
            commission_other: '',
            commission_return_refund: '',
            postage_shipping: '',
            postage_return: ''})
        }
      })
    },
    postChannels (channels) {
      this.reverseFormat(channels)
      API.post('uvp/sales-channels', channels)
        .then(res => {
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
        })
    },
    calculateVkmin () {
      API.post('uvp/vkmin', {cost_price: parseFloat(this.vkminPrice.replace(',', '.')), season: this.vkminSeason, manufacturer: this.vkminManufacturer.id})
        .then(res => {
          this.vkminResult = res.data
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
        })
    },
    calculateRoi () {
      API.post('uvp/roi', {cost_price: parseFloat(this.roiPrice.replace(',', '.')), season: this.roiSeason, manufacturer: this.roiManufacturer, selling_price: parseFloat(this.roiSellingPrice.replace(',', '.'))})
        .then(res => {
          this.roiResult = res.data
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!'})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'error', dismiss: 4, message: 'Error!'})
        })
    },
    getClass (a, b) {
      if (a > 0) {
        if (a > b) {
          return 'text-success'
        } return 'text-warning'
      } else {
        return 'text-danger'
      }
    },
    formatData (data) {
      Object.keys(data).forEach(e => {
        e.toString().replace('.', ',')
      })
    },
    reverseFormat (data) {
      data.forEach(c => {
        Object.keys(c).forEach(e => {
          if (e !== 'name') {
            let val = c[e].toString()
            c[e] = parseFloat(val.replace(',', '.'))
          }
        })
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('uvp')
        .then(res => {
          this.generateDevaluations()
          this.config = res.data.company_configuration
          this.companyDevaluations = res.data.company_devaluations.length === 0 ? this.generateDevaluations() : res.data.company_devaluations
          this.companyManufacturers = res.data.company_manufacturers
          this.manufacturers = res.data.manufacturers
          this.salesChannels = res.data.sales_channels
          this.seasons = res.data.seasons
          this.companyChannels = res.data.company_sales_channels
          this.generateChannels()
          this.formatData(this.config)
          this.companyChannels.forEach(c => {
            this.formatData(c)
          })
          this.companyDevaluations.forEach(c => {
            this.formatData(c)
          })
          this.companyManufacturers.forEach(c => {
            this.formatData(c)
          })
        })
    })
  },
  watch: {
    companyDevaluations () {}
  }
}
</script>
<style scoped>
  select option.normal{margin:40px;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4)}select option.normal{background:#202227}
  .alert.alert-message {
    position: fixed;
  }
  .alert-dismissible {
    z-index: 9999;
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Settings/Uvp.vue